module.exports = __webpack_public_path__ + "static/media/emojis_23.c6af7320.svg";